import React, { useState } from 'react';
import { sendEmail } from '../controller.js';
import ReCAPTCHA from 'react-google-recaptcha';

import Brian_Huhn_Resume from '../assets/Brian_Huhn_Resume.pdf';

const RECAPTCHA_SITE_KEY = '6LfCai8rAAAAAAmbuUbyai5mssEpJBqSPCQot0rr';

const jobs = [
  {
    range: '2026-Present',
    role: 'Cloud Engineer',
    company: 'MTSI',
    description: 'Develops and manages cloud platforms for intelligence platforms.',
    tags: ['Go', 'JDK', 'Kubernetes', 'Opensearch', 'Docker', 'Coder'],
  },
  {
    range: '2023 — 2026',
    role: 'Senior Staff Software Engineer',
    company: 'Booz Allen Hamilton',
    description:
      'Full-stack technical lead on the VA Veterans Benefits Management System — a regulated federal platform serving hundreds of thousands of veterans. Own architecture across TypeScript, React, OpenSearch, and GraphQL. Drive 508/ADA compliance, lead sprint demos, and coordinate cross-team delivery in a SAFe program. Integrated AI-assisted tooling (Copilot, Claude) to increase code velocity. Mentored junior engineers on TypeScript best practices and component architecture.',
    tags: ['TypeScript', 'React', 'OpenSearch', 'GraphQL', '508/ADA', 'SAFe', 'GitHub Copilot', 'Claude AI'],
  },
  {
    range: '2021 — 2023',
    role: 'Software Engineer II',
    company: 'Ball Aerospace',
    description:
      'Production full-stack development across classified NASIC intelligence programs. Built automated test suites that reduced manual QA overhead and delivered milestone demos to defense stakeholders.',
    tags: ['Classified programs', 'Full-stack', 'Test automation'],
  },
  {
    range: '2019 - 2019',
    role: 'Applications QA Intern',
    company: 'London Computer Systems',
    description: 'Collaborated with developers into implementing features as well as presenting them to the CEO',
    tags: [],
  },
  {
    range: '2018 — 2019',
    role: 'Full-Stack Intern',
    company: 'Ridge Tool Company (Emerson)',
    description:
      'Led development and launch of Greenlee.com. Maintained web apps across Emerson subsidiaries and conducted peer code reviews.',
    tags: ['Greenlee.com', 'SQL'],
  },
];

const s = {
  right: {
    padding: '2.5rem',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '3rem',
    minHeight: '100vh',
    background: 'var(--color-background-primary)',
  },
  sectionLabelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '1.25rem',
  },
  sectionLabel: {
    fontSize: '10px',
    fontFamily: "'DM Mono', monospace",
    color: 'var(--color-text-secondary)',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  sectionLine: {
    flex: 1,
    height: '0.5px',
    background: 'var(--color-border-tertiary)',
  },
  expItem: {
    display: 'grid',
    gridTemplateColumns: '90px 1fr',
    gap: '0 1.5rem',
    paddingBottom: '1.5rem',
    marginBottom: '1.5rem',
    borderBottom: '0.5px solid var(--color-border-tertiary)',
  },
  expItemLast: {
    display: 'grid',
    gridTemplateColumns: '90px 1fr',
    gap: '0 1.5rem',
  },
  expYear: {
    fontSize: '11px',
    fontFamily: "'DM Mono', monospace",
    color: 'var(--color-text-secondary)',
    paddingTop: '2px',
  },
  expRole: {
    fontSize: '15px',
    fontWeight: 500,
    color: 'var(--color-text-primary)',
    marginBottom: '2px',
  },
  expCompany: {
    fontSize: '12px',
    fontFamily: "'DM Mono', monospace",
    color: 'var(--color-text-secondary)',
    marginBottom: '10px',
  },
  expDesc: {
    fontSize: '13px',
    color: 'var(--color-text-secondary)',
    lineHeight: 1.6,
    fontWeight: 300,
  },
  expTags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '5px',
    marginTop: '10px',
  },
  expTag: {
    fontSize: '10px',
    fontFamily: "'DM Mono', monospace",
    background: 'var(--color-background-secondary)',
    color: 'var(--color-text-secondary)',
    border: '0.5px solid var(--color-border-tertiary)',
    padding: '3px 8px',
    borderRadius: '3px',
  },
  projectsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px',
  },
  projectCard: {
    background: 'var(--color-background-primary)',
    border: '0.5px solid var(--color-border-tertiary)',
    borderRadius: 'var(--border-radius-lg)',
    padding: '1.25rem',
  },
  projectCardFeatured: {
    background: 'var(--color-background-primary)',
    border: '0.5px solid var(--color-border-tertiary)',
    borderRadius: 'var(--border-radius-lg)',
    padding: '1.25rem',
    gridColumn: '1 / -1',
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    alignItems: 'start',
    gap: '1rem',
  },
  projectName: {
    fontSize: '14px',
    fontWeight: 500,
    color: 'var(--color-text-primary)',
    marginBottom: '5px',
  },
  projectDesc: {
    fontSize: '12px',
    color: 'var(--color-text-secondary)',
    lineHeight: 1.5,
    fontWeight: 300,
  },
  projectMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '12px',
  },
  liveBadge: {
    fontSize: '10px',
    fontFamily: "'DM Mono', monospace",
    color: '#4ade80',
    background: 'rgba(74,222,128,0.1)',
    border: '0.5px solid rgba(74,222,128,0.25)',
    padding: '2px 8px',
    borderRadius: '3px',
  },
  wipBadge: {
    fontSize: '10px',
    fontFamily: "'DM Mono', monospace",
    color: 'var(--color-text-secondary)',
    background: 'var(--color-background-secondary)',
    border: '0.5px solid var(--color-border-tertiary)',
    padding: '2px 8px',
    borderRadius: '3px',
  },
  visitBtn: {
    fontSize: '11px',
    fontFamily: "'DM Mono', monospace",
    color: 'var(--color-text-secondary)',
    border: '0.5px solid var(--color-border-tertiary)',
    background: 'transparent',
    padding: '6px 14px',
    borderRadius: 'var(--border-radius-md)',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  formInput: {
    width: '100%',
    background: 'var(--color-background-secondary)',
    border: '0.5px solid black',
    color: 'var(--color-text-primary)',
    borderRadius: '4px',
    padding: '10px',
    fontFamily: "'Outfit', sans-serif",
    fontSize: '13px',
    outline: 'none',
    marginBottom: '10px',
    display: 'block',
  },
  submitBtn: {
    background: '#f0ede6',
    color: '#0c0c0c',
    border: 'none',
    padding: '8px 20px',
    fontFamily: "'DM Mono', monospace",
    fontSize: '12px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: '10px',
  },
  formLabel: {
    fontSize: '11px',
    fontFamily: "'DM Mono', monospace",
    color: 'var(--color-text-secondary)',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    marginBottom: '4px',
    display: 'block',
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px',
  },
  resumeLink: {
    fontSize: '12px',
    fontFamily: "'DM Mono', monospace",
    color: 'var(--color-text-secondary)',
    border: '0.5px solid var(--color-border-tertiary)',
    background: 'transparent',
    padding: '6px 14px',
    borderRadius: 'var(--border-radius-md)',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    marginTop: '1rem',
  },
};

const SectionLabel = ({ children }) => (
  <div style={s.sectionLabelRow}>
    <span style={s.sectionLabel}>{children}</span>
    <div style={s.sectionLine} />
  </div>
);

const RightPane = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [desc, setDesc] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);
  const [visitHover, setVisitHover] = useState(false);

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const sendEmailLocal = async (e) => {
    if (!captchaToken) {
      alert('Please complete the CAPTCHA.');
      return;
    }

    if (firstName === '' || lastName === '' || email === '' || desc === '') {
      return;
    }

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      return;
    }

    const params = {
      to: email,
      subject: `New email from ${firstName} ${lastName}`,
      text: desc,
      html: `<p><strong>Message from:</strong> ${firstName}</p><p><strong>Email:</strong> ${email}</p><p><strong>Message:</strong><br>${desc}</p>`,
      captchaToken: captchaToken,
    };
    await sendEmail(params);
    setFirstName('');
    setLastName('');
    setEmail('');
    setDesc('');
  };

  return (
    <div style={s.right}>
      {/* EXPERIENCE */}
      <section>
        <SectionLabel>Experience</SectionLabel>
        {jobs.map((job, i) => (
          <div key={job.company} style={i < jobs.length - 1 ? s.expItem : s.expItemLast}>
            <div style={s.expYear}>{job.range}</div>
            <div>
              <div style={s.expRole}>{job.role}</div>
              <div style={s.expCompany}>{job.company}</div>
              <div style={s.expDesc}>{job.description}</div>
              <div style={s.expTags}>
                {job.tags.map(t => <span key={t} style={s.expTag}>{t}</span>)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* EDUCATION */}
      <section>
        <SectionLabel>Education</SectionLabel>
        <div style={s.expItemLast}>
          <div style={s.expYear}>2021</div>
          <div>
            <div style={s.expRole}>B.S. Computer Engineering</div>
            <div style={s.expCompany}>University of Toledo</div>
          </div>
        </div>
      </section>

      {/* PROJECTS */}
      <section>
        <SectionLabel>Projects</SectionLabel>
        <div style={s.projectsGrid}>
          {/* Featured card */}
          <div style={s.projectCardFeatured}>
            <div>
              <div style={s.projectName}>AroundEverything.com</div>
              <div style={s.projectDesc}>
                Cincinnati-area event discovery platform. Built on the Eventbrite API with company registration, custom event creation, and public discovery — live and shipping.
              </div>
              <div style={s.projectMeta}>
                <span style={s.liveBadge}>live</span>
              </div>
            </div>
            <button
              aria-label="Visit AroundEverything.com"
              style={{
                ...s.visitBtn,
                ...(visitHover ? { background: 'var(--color-background-secondary)' } : {}),
              }}
              onMouseEnter={() => setVisitHover(true)}
              onMouseLeave={() => setVisitHover(false)}
              onClick={() => window.open('https://www.aroundeverything.com/', '_blank', 'noopener,noreferrer')}
            >
              Visit →
            </button>
          </div>

          {/* Options Simulator */}
          <div style={s.projectCard}>
            <div style={s.projectName}>Options Simulator</div>
            <div style={s.projectDesc}>
              Mock trading and options simulator. Real market mechanics without real money.
            </div>
            <div style={s.projectMeta}>
              <span style={s.wipBadge}>in progress</span>
            </div>
          </div>

          {/* brianhuhn.com */}
          <div style={s.projectCard}>
            <div style={s.projectName}>brianhuhn.com</div>
            <div style={s.projectDesc}>
              This portfolio — built in React with a sticky split-panel layout.
            </div>
            <div style={s.projectMeta}>
              <span style={s.liveBadge}>live</span>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section>
        <SectionLabel>Contact</SectionLabel>
        <div style={s.formRow}>
          <div>
            <label style={s.formLabel} htmlFor="fName">First Name</label>
            <input
              id="fName"
              style={s.formInput}
              type="text"
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
              required
            />
          </div>
          <div>
            <label style={s.formLabel} htmlFor="lName">Last Name</label>
            <input
              id="lName"
              style={s.formInput}
              type="text"
              value={lastName}
              onChange={e => setLastName(e.target.value)}
              required
            />
          </div>
        </div>
        <label style={s.formLabel} htmlFor="email">Email</label>
        <input
          id="email"
          style={s.formInput}
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <label style={s.formLabel} htmlFor="description">Description</label>
        <textarea
          id="description"
          style={{ ...s.formInput, resize: 'vertical', minHeight: '100px' }}
          value={desc}
          onChange={e => setDesc(e.target.value)}
          rows={4}
          required
        />
        <ReCAPTCHA
          sitekey={RECAPTCHA_SITE_KEY}
          onChange={handleCaptchaChange}
          style={{ margin: '10px 0' }}
        />
        <button
          style={{ ...s.submitBtn, ...(!captchaToken ? { opacity: 0.4, cursor: 'not-allowed' } : {}) }}
          onClick={sendEmailLocal}
          disabled={!captchaToken}
        >
          Submit
        </button>

        <a href={Brian_Huhn_Resume} download="Brian_Huhn_Resume.pdf" style={s.resumeLink}>
          Download Resume ↓
        </a>
      </section>
    </div>
  );
};

export default RightPane;